import { render, staticRenderFns } from "./MyPageDocumentUpdate.vue?vue&type=template&id=b36250d4&scoped=true"
import script from "./MyPageDocumentUpdate.vue?vue&type=script&lang=js"
export * from "./MyPageDocumentUpdate.vue?vue&type=script&lang=js"
import style0 from "./MyPageDocumentUpdate.vue?vue&type=style&index=0&id=b36250d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36250d4",
  null
  
)

export default component.exports